import { useEffect, useState } from 'react'

const fillsScreen = (): boolean =>
	window.innerWidth >= window.screen.availWidth * 0.9

/** Whether this window is about as wide as its screen, kept current. */
export const useFillsScreen = (): boolean => {
	const [fills, setFills] = useState(fillsScreen)
	useEffect(() => {
		const onResize = (): void => setFills(fillsScreen())
		window.addEventListener('resize', onResize)
		return () => window.removeEventListener('resize', onResize)
	}, [])
	return fills
}
